import { LoadingGhost, SelectDropdown, StateHandler } from "src/components";
import { useGetUserAccessMeQuery } from "src/datahandling/redux/api/rtkQueryCodeGen/accessApi/accessApiInjections";
import { useCustomerSettingsContext } from "src/contexts";
import { useCompanySelectorTransformer } from "./Data/useCompanySelector.transform";
import type { CompanyType } from "src/models/types/userSettings.types";

export namespace CompanySelector {
    export type Props = {};
}

export const CompanySelector = () => {
    const { setSelectedCompany, selectedCompany } = useCustomerSettingsContext();
    const userAccessQuery = useGetUserAccessMeQuery({ ignoreCache: false });

    return(
        <StateHandler 
            statefullObjectMap={{ userAccessQuery }}
            loadingGraphic={<LoadingGhost width="10rem" height="1.5rem" />}
        >
            {(data) => {
                const { options, selected } = useCompanySelectorTransformer(data.userAccessQuery, selectedCompany);

                return(
                    <SelectDropdown
                        onChange={(item) => {
                            setSelectedCompany(item.value as CompanyType);
                        }}
                        trigger={{
                            variant: "ghost",
                            color: "neutral",
                            size: "medium",
                            text: selected.text,
                            useChevrons: true,
                        }}
                        options={options}
                        preSelected={selected ?? options[0]}
                    />
                );
            }}
        </StateHandler>
    );
}